export class FetchError extends Error {
  constructor(data = {}) {
    super();
    this.data = data;
  }
}